export default "__VITE_ASSET__BBOXiWY8__";